import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { DOCUMENT } from "@angular/platform-browser";
import { Title } from '@angular/platform-browser';
import { SlideShowModel } from "../models/slideshow.model";
import { PictureModel } from "../models/picture.model";
import { Announcer } from "../models/announcer.model";
import { Box } from '../models/box';
import { Quote } from '../models/qoute.model';
import { SlideNotifier } from '../models/slideNotifier.model';
import { NotificationService } from '../services/notification.service';
import { FireBaseService } from '../services/firebase.service';

declare var require: any

@Component({
  selector: 'dedo-wedding',
  templateUrl: './home.component.html',
  styleUrls: ['../app.component.css']
})
export class HomeComponent implements OnInit {
  public gif = require('../../assets/images/wedding/andy_jeska/53.jpg');
  public slideShowModel: SlideShowModel;
  public aboutUs: Announcer;
  public location: Announcer;
  public details: Announcer;
  public quote: Quote;

  public photo = require('../../assets/images/wedding/andy_jeska/53.jpg');
  public imgData: string = `url(${this.photo})`;
  public photo3 = require('../../assets/images/wedding/andy_jeska/600x600/IMG_1096.jpg');
  public imgData3: string = `url(${this.photo3})`;
  public photo4 = require('../../assets/images/wedding/andy_jeska/600x600/10100100896_8b80e531d1_k.jpg');
  public imgData4: string = `url(${this.photo4})`;
  public photo5 = require('../../assets/images/wedding/600x600/q9nabuuiuvq-scott-webb.jpg');
  public imgData5: string = `url(${this.photo5})`;
  public photo6 = require('../../assets/images/wedding/andy_jeska/IMG_8627.jpg');
  public imgData6: string = `url(${this.photo6})`;
  public photo7 = require('../../assets/images/wedding/andy_jeska/36.jpg');
  public imgData7: string = `url(${this.photo7})`;
  public photo8 = require('../../assets/images/wedding/andy_jeska/36.jpg');
  public imgData8: string = `url(${this.photo8})`;  

  constructor(private notificationService: NotificationService,
    fbService: FireBaseService) {
    fbService
      .getDoc<SlideNotifier>("/SlideNotifiers/home")  
      .subscribe((dto) => this.notificationService.notifySlide(dto));
  }

  ngOnInit(): void {
    this.slideShowModel = new SlideShowModel();
    this.slideShowModel.title = "Ngày hôm nớ";
    this.slideShowModel.description = `Cô Dâu và Chú Rể học chung trường cấp 2, chung trường cấp 3 và sống chung một khu phố. 
    Cả 2 cùng chung một người chủ và giờ đây phải đối diện với đấng tối cao của mình ...`;
    let url: string;
    let type: string;
    let picture: PictureModel;

    for (let i = 0; i < 14; i++) {
      url = require(`../../assets/images/private/home/slide${i}.jpg`);
      type = i % 2 == 0 ? 'codau' : 'chure';

      picture = new PictureModel();
      picture.id = i;
      picture.src = url;
      picture.type = type;

      this.slideShowModel.pictures.push(picture);
    }
    // about us
    this.aboutUs = new Announcer(null,
      require('../../assets/images/animations/flowers3.gif'),
      "Chuyện của chúng tôi",
      "Ngày 9 Tháng 4 Năm 2018",
      `"Từ 2007 đến tận bây giờ".</br> 
          Chú rể đã may mắn khi không trở thành Tiến Đạt`
    );
    this.location = new Announcer(
      require('../../assets/images/wedding/andy_jeska/10096243776_4e750f391d_k.jpg'),
      require('../../assets/images/animations/save_gold.gif'),
      "09/04/2018",
      "19 Nguyễn Tuân - TP. Tam Kỳ",
      null
    );

    let boxes: Box[] = [];
    boxes.push(new Box(this.photo3,
      "Lễ Đính Hôn",
      `<strong>Tư gia cô dâu</strong>
        <br>Tam Kỳ, Quảng Nam</p>`, "/ceremony/1"));
    boxes.push(new Box(require('../../assets/images/wedding/andy_jeska/600x600/backup.jpg'),
      "Lễ Cáo Gia Tiên",
      `<strong>Nhà nội cô dâu</strong>
        <br>Bình Quý, Thăng Bình, Quảng Nam</p>`, "/ceremony/2"));
    boxes.push(new Box(require('../../assets/images/wedding/andy_jeska/600x600/IMG_8011.jpg'),
      "Lễ Vu Quy",
      `<strong>Nhà hàng tiệc cưới Mai Hạc</strong>
          <br>Tam Kỳ, Quảng Nam</p>`, "/ceremony/3"));
    boxes.push(new Box(require('../../assets/images/wedding/andy_jeska/600x600/IMG_8337.jpg'),
      "Lễ Thành Hôn",
      `<strong>Nhà hàng tiệc cưới Trầu Cau</strong>
            <br>Tam Kỳ, Quảng Nam</p>`, "/ceremony/4"));
    boxes.push(new Box(require('../../assets/images/wedding/andy_jeska/600x600/IMG_8697.jpg'),
      "Lễ Rước Dâu",
      `<strong>Tư Gia chú rể</strong>
              <br>Nguyễn Tuân, Tam Kỳ, Quảng Nam</p>`, "/ceremony/5"));
    boxes.push(new Box(require('../../assets/images/wedding/andy_jeska/600x600/IMG_8740.jpg'),
      "Tiệc Báo Hỷ",
      `<strong>Nhà hàng tiệc cưới Tân Sơn Nhất</strong>
              <br>Hoàng Văn Thụ, Tp.Hồ Chí Minh</p>`, "/ceremony/6"));

    this.details = new Announcer(null,
      require('../../assets/images/animations/flowers2.gif'),
      "The Wedding",
      "Lễ cưới & Tam Kỳ",
      `Lễ cưới diễn ra tại thành phố Tam Kỳ xinh đẹp và đẳng cấp. Bên cạnh dòng sông Bàn Thạch bao mùa bèo trôi không ai vớt...
       `,
      boxes = boxes
    );

    this.quote = new Quote(
      require('../../assets/images/animations/flowers2.gif'),
      this.photo6,
      "Cảm ơn bố mẹ, gia đình hai bên",
      "cùng các anh, chị em, bạn bè, đồng nghiệp"
    );
  }
}




// WEBPACK FOOTER //
// ./src/app/home/home.component.ts